module.exports = __webpack_public_path__ + "5362891536c2d7c8b18a315b46800f66.svg";